import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faLock, faUser, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from 'components/Navigation';
import ConfirmModal from 'components/ConfirmModal';
import { authService } from 'services/authService';
import {
  Body,
  Header,
  BackButton,
  MenuList,
  MenuItem,
  MenuIcon,
  MenuText
} from './AccountManagement.styles';

const AccountManagement: React.FC = () => {
  const navigate = useNavigate();
  const isGuest = localStorage.getItem("guestMode") === "true";
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState<boolean>(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleChangePassword = () => {
    navigate('/change-password');
  };

  const handleDeleteAccount = () => {
    navigate('/withdraw-account');
  };

  const handleLogout = () => {
    setIsLogoutModalOpen(true);
  };

  const handleConfirmLogout = async () => {
    setIsLogoutModalOpen(false);
    await authService.logout();
  };

  const handleCancelLogout = () => {
    setIsLogoutModalOpen(false);
  };

  return (
    <Body>
      <Header>
        <BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </BackButton>
        계정 관리
      </Header>

      <MenuList>
        <MenuItem onClick={isGuest ? undefined : handleChangePassword} disabled={isGuest}>
          <MenuIcon>
            <FontAwesomeIcon icon={faLock} />
          </MenuIcon>
          <MenuText>비밀번호 변경</MenuText>
        </MenuItem>

        <MenuItem onClick={isGuest ? undefined : handleDeleteAccount} disabled={isGuest}>
          <MenuIcon>
            <FontAwesomeIcon icon={faUser} />
          </MenuIcon>
          <MenuText>회원 탈퇴</MenuText>
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <MenuIcon>
            <FontAwesomeIcon icon={faRightFromBracket} />
          </MenuIcon>
          <MenuText>로그아웃</MenuText>
        </MenuItem>
      </MenuList>

      <ConfirmModal
        isOpen={isLogoutModalOpen}
        title="로그아웃"
        message="정말 로그아웃 하시겠습니까?"
        confirmText="로그아웃"
        cancelText="취소"
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
      />

      <NavigationBar />
    </Body>
  );
};

export default AccountManagement;
